import { render, staticRenderFns } from "./paymentPse.vue?vue&type=template&id=58706ac6"
import script from "./paymentPse.vue?vue&type=script&lang=js"
export * from "./paymentPse.vue?vue&type=script&lang=js"
import style0 from "./paymentPse.vue?vue&type=style&index=0&id=58706ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports